module.exports = __webpack_public_path__ + "img/linkedin-logo.30c453b7.png";